const SET_PATIENT = 'patient//SET_PATIENT'
const REMOVE_PATIENT = 'patient//REMOVE_PATIENT'

export {
  SET_PATIENT,
  REMOVE_PATIENT
}
